import React from "react";
import { CircularProgress } from "@mui/material";
import StyledContainer from "./LoadingOverlay.styles";

type LoadingOverlayProps = {
  loading: boolean;
  /** DFT-0026: optional testId for consumers that need to assert on the
   * overlay's presence (e.g. BayHireOperationsQueue). Additive - existing
   * callers that don't pass it are unaffected. */
  testId?: string;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading, testId }) => {
  if (!loading) return null;

  return (
    <StyledContainer
      data-testid={testId}
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </StyledContainer>
  );
};

export default LoadingOverlay;
